import { api_authUserLogout } from "./axios";

// Shared across Login mounts: a late logout must never race a new login.
// A reload preserves the need to clear server cookies, but never claims success.
const PENDING_KEY = "stats-insight-logout-pending";
let status = sessionStorage.getItem(PENDING_KEY) === "true" ? "error" : "idle";
let pending = null;
const listeners = new Set();
const publish = (next) => { status = next; listeners.forEach((listener) => listener()); };
export const subscribeLogout = (listener) => { listeners.add(listener); return () => listeners.delete(listener); };
export const getLogoutStatus = () => status;
export const clearLogoutNotice = () => { if (status === "success") publish("idle"); };
export const requestServerLogout = () => {
  if (pending) return pending;
  sessionStorage.setItem(PENDING_KEY, "true");
  publish("pending");
  pending = Promise.resolve().then(api_authUserLogout).then((response) => {
    if (response?.status !== true) throw new Error("Logout not confirmed");
    sessionStorage.removeItem(PENDING_KEY);
    publish("success");
  }).catch(() => {
    publish("error");
  }).finally(() => { pending = null; });
  return pending;
};
